
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import { clients } from '../../mocks/clients';

export default function ClientsPage() {
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [filter, setFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('list');

  const getStatusColor = (status: string) => {
    switch (status) {
      case '长期合作':
        return 'bg-green-100 text-green-800';
      case '活跃合作':
        return 'bg-blue-100 text-blue-800';
      case '新客户':
        return 'bg-yellow-100 text-yellow-800';
      case '潜在客户':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const filteredClients =
    filter === 'all' ? clients : clients.filter((client) => client.cooperationStatus === filter);

  const renderClientDetail = () => {
    if (!selectedClient) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-5xl w-full mx-4 max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-building-line text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">{selectedClient.companyName}</h2>
                  <p className="text-gray-600">{selectedClient.industry}</p>
                </div>
              </div>
              <button
                onClick={() => setSelectedClient(null)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
          </div>

          <div className="p-6 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">公司信息</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-500">合作状态:</span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                        selectedClient.cooperationStatus,
                      )}`}
                    >
                      {selectedClient.cooperationStatus}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">行业:</span>
                    <span className="font-medium">{selectedClient.industry}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">规模:</span>
                    <span className="font-medium">{selectedClient.scale}人</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">地点:</span>
                    <span className="font-medium">{selectedClient.location}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">合作项目:</span>
                    <span className="font-medium">{selectedClient.projectCount} 个</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">最后联系:</span>
                    <span className="font-medium">{selectedClient.lastContact}</span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">联系信息</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-500">联系人:</span>
                    <span className="font-medium">{selectedClient.contactPerson}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">电话:</span>
                    <span className="font-medium">{selectedClient.phone}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">邮箱:</span>
                    <span className="font-medium">{selectedClient.email}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">地址:</span>
                    <p className="font-medium mt-1">{selectedClient.address}</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">合作统计</h3>
                <div className="space-y-3">
                  <div className="bg-blue-50 p-3 rounded-lg">
                    <div className="text-lg font-bold text-blue-600">总合作金额</div>
                    <div className="text-2xl font-bold text-blue-800">
                      ¥{(selectedClient.projectCount * 50000).toLocaleString()}
                    </div>
                  </div>
                  <div className="bg-green-50 p-3 rounded-lg">
                    <div className="text-lg font-bold text-green-600">成功率</div>
                    <div className="text-2xl font-bold text-green-800">85%</div>
                  </div>
                  <div className="bg-purple-50 p-3 rounded-lg">
                    <div className="text-lg font-bold text-purple-600">满意度</div>
                    <div className="text-2xl font-bold text-purple-800">4.8/5</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">公司描述</h3>
              <p className="text-gray-700 leading-relaxed">{selectedClient.description}</p>
            </div>

            {/* 沟通记录 */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">最近沟通记录</h3>
              <div className="space-y-3">
                {[
                  { date: '2024-01-15', type: '电话', content: '讨论新项目需求，确定招聘计划', person: '张经理' },
                  { date: '2024-01-10', type: '邮件', content: '发送候选人简历，等待反馈', person: '李专员' },
                  { date: '2024-01-05', type: '会议', content: '项目启动会议，明确招聘要求', person: '王总监' },
                ].map((record, index) => (
                  <div key={index} className="flex items-start space-x-4 p-3 bg-gray-50 rounded-lg">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <i
                        className={`${
                          record.type === '电话'
                            ? 'ri-phone-line'
                            : record.type === '邮件'
                            ? 'ri-mail-line'
                            : 'ri-calendar-line'
                        } text-blue-600`}
                      ></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-medium text-gray-900">{record.type}</span>
                        <span className="text-sm text-gray-500">{record.date}</span>
                      </div>
                      <p className="text-gray-700 text-sm">{record.content}</p>
                      <p className="text-gray-500 text-xs mt-1">负责人: {record.person}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end space-x-4">
              <Button variant="outline">编辑信息</Button>
              <Button variant="outline">查看项目</Button>
              <Button variant="outline">添加沟通记录</Button>
              <Button>新建项目</Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderAIFeatures = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">AI智能功能</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="客户行业新闻监测">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-news-line text-blue-600"></i>
                <span className="font-medium text-blue-800">实时监测</span>
              </div>
              <div className="text-sm text-blue-700">
                已监测 <span className="font-bold">23</span> 个客户行业动态
              </div>
            </div>
            <div className="space-y-3">
              {[
                {
                  company: '阿里巴巴',
                  news: '宣布新一轮组织架构调整，预计增加500个技术岗位',
                  time: '2小时前',
                },
                {
                  company: '腾讯',
                  news: '启动数字化转型项目，大量招聘AI工程师',
                  time: '5小时前',
                },
                {
                  company: '字节跳动',
                  news: '海外业务扩张，计划在新加坡设立研发中心',
                  time: '1天前',
                },
              ].map((item, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-gray-900">{item.company}</span>
                    <span className="text-xs text-gray-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-gray-700">{item.news}</p>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="客户关系预测">
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-line-chart-line text-green-600"></i>
                <span className="font-medium text-green-800">关系分析</span>
              </div>
              <div className="text-sm text-green-700">
                预测 <span className="font-bold">12</span> 个客户有续约意向
              </div>
            </div>
            <div className="space-y-3">
              {[
                { client: '阿里巴巴', score: 95, trend: 'up', prediction: '极可能续约' },
                { client: '腾讯', score: 78, trend: 'stable', prediction: '可能续约' },
                { client: '字节跳动', score: 65, trend: 'down', prediction: '需要关注' },
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div>
                    <div className="font-medium text-gray-900">{item.client}</div>
                    <div className="text-sm text-gray-600">{item.prediction}</div>
                  </div>
                  <div className="text-right">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-medium">{item.score}%</span>
                      <i
                        className={`ri-arrow-${item.trend === 'up' ? 'up' : item.trend === 'down' ? 'down' : 'right'}-line text-${
                          item.trend === 'up' ? 'green' : item.trend === 'down' ? 'red' : 'gray'
                        }-600`}
                      ></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>

      <Card title="潜在客户推荐">
        <div className="space-y-4">
          <div className="bg-purple-50 p-4 rounded-lg">
            <div className="flex items-center space-x-2 mb-2">
              <i className="ri-user-search-line text-purple-600"></i>
              <span className="font-medium text-purple-800">智能推荐</span>
            </div>
            <div className="text-sm text-purple-700">
              基于行业分析，为您推荐 <span className="font-bold">8</span> 个潜在客户
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              {
                company: '美团',
                industry: '互联网',
                score: 88,
                reason: '同行业高增长公司，招聘需求旺盛',
              },
              {
                company: '滴滴出行',
                industry: '互联网',
                score: 82,
                reason: '业务扩张期，技术团队快速增长',
              },
              {
                company: '小米',
                industry: '科技',
                score: 79,
                reason: '生态链扩张，多领域人才需求',
              },
              {
                company: '京东',
                industry: '电商',
                score: 75,
                reason: '物流科技升级，需要大量技术人才',
              },
            ].map((item, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-medium text-gray-900">{item.company}</h4>
                  <span className="text-sm font-medium text-purple-600">{item.score}%匹配</span>
                </div>
                <p className="text-sm text-gray-600 mb-2">{item.industry}</p>
                <p className="text-xs text-gray-500">{item.reason}</p>
                <div className="flex justify-end mt-3">
                  <Button size="sm" variant="outline">
                    联系
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );

  const renderClientList = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">客户管理</h1>
          <p className="text-gray-600">管理所有客户信息和合作关系</p>
        </div>
        <Button onClick={() => setShowCreateModal(true)}>
          <i className="ri-add-line mr-2"></i>
          添加客户
        </Button>
      </div>

      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card>
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600 mb-1">{clients.length}</div>
            <div className="text-sm text-gray-600">总客户数</div>
          </div>
        </Card>
        <Card>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600 mb-1">
              {clients.filter((c) => c.cooperationStatus === '长期合作').length}
            </div>
            <div className="text-sm text-gray-600">长期合作</div>
          </div>
        </Card>
        <Card>
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600 mb-1">
              {clients.filter((c) => c.cooperationStatus === '活跃合作').length}
            </div>
            <div className="text-sm text-gray-600">活跃合作</div>
          </div>
        </Card>
        <Card>
          <div className="text-center">
            <div className="text-2xl font-bold text-yellow-600 mb-1">
              {clients.reduce((sum, c) => sum + c.projectCount, 0)}
            </div>
            <div className="text-sm text-gray-600">总项目数</div>
          </div>
        </Card>
      </div>

      {/* 筛选条件 */}
      <Card>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <span className="text-sm font-medium text-gray-700">合作状态:</span>
            <div className="flex space-x-2">
              {['all', '长期合作', '活跃合作', '新客户', '潜在客户'].map((status) => (
                <button
                  key={status}
                  onClick={() => setFilter(status)}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap ${
                    filter === status
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {status === 'all' ? '全部' : status}
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Input placeholder="搜索客户..." className="w-64" />
            <Button variant="outline">
              <i className="ri-filter-line mr-2"></i>
              筛选
            </Button>
          </div>
        </div>
      </Card>

      {/* 客户列表 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {filteredClients.map((client) => (
          <Card key={client.id} className="cursor-pointer hover:shadow-lg transition-shadow duration-200">
            <div className="space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className="ri-building-line text-blue-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{client.companyName}</h3>
                    <p className="text-gray-600">{client.industry}</p>
                  </div>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(client.cooperationStatus)}`}>
                  {client.cooperationStatus}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center space-x-2">
                  <i className="ri-team-line text-gray-600"></i>
                  <span>{client.scale}人</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-map-pin-line text-gray-600"></i>
                  <span>{client.location}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-briefcase-line text-blue-600"></i>
                  <span>{client.projectCount} 个项目</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-phone-line text-green-600"></i>
                  <span>{client.contactPerson}</span>
                </div>
              </div>

              <div className="text-sm text-gray-600">
                <p className="line-clamp-2">{client.description}</p>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="text-sm text-gray-500">最后联系: {client.lastContact}</div>
                <div className="flex space-x-2">
                  <Button size="sm" variant="outline" onClick={() => setSelectedClient(client)}>
                    查看详情
                  </Button>
                  <Button size="sm">联系</Button>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {filteredClients.length === 0 && (
        <Card>
          <div className="text-center py-12">
            <i className="ri-building-line text-4xl text-gray-400 mb-4"></i>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">暂无客户</h3>
            <p className="text-gray-500">请添加新的客户信息</p>
          </div>
        </Card>
      )}
    </div>
  );

  const renderClientArchive = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">客户档案 - 多层组织架构</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="公司基本信息">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-building-line text-blue-600"></i>
                <span className="font-medium text-blue-800">企业信息管理</span>
              </div>
              <div className="text-sm text-blue-700">
                已录入 <span className="font-bold">{clients.length}</span> 家企业的完整信息
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                { field: '公司全称', value: '阿里巴巴集团控股有限公司', icon: 'ri-building-line' },
                { field: '统一社会信用代码', value: '91330000MA27XK4A0E', icon: 'ri-file-text-line' },
                { field: '注册资本', value: '1,200,000万元', icon: 'ri-money-dollar-circle-line' },
                { field: '成立时间', value: '1999-09-09', icon: 'ri-calendar-line' },
                { field: '法定代表人', value: '张勇', icon: 'ri-user-line' },
                { field: '经营状态', value: '存续', icon: 'ri-check-line' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <i className={`${item.icon} text-gray-600`}></i>
                    <span className="text-sm text-gray-700">{item.field}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="多层组织架构">
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-organization-chart text-purple-600"></i>
                <span className="font-medium text-purple-800">组织架构图</span>
              </div>
              <div className="text-sm text-purple-700">
                集团 → 子公司 → 部门三级架构管理
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="border-l-4 border-blue-500 pl-4">
                <div className="font-medium text-gray-900">阿里巴巴集团</div>
                <div className="text-sm text-gray-600 mt-1">集团总部 · 杭州</div>
                <div className="mt-2 space-y-2">
                  <div className="border-l-4 border-green-500 pl-4 ml-4">
                    <div className="font-medium text-gray-800">淘宝网络有限公司</div>
                    <div className="text-sm text-gray-600">子公司 · 杭州</div>
                    <div className="mt-1 space-y-1 ml-4">
                      <div className="text-sm text-gray-700">• 技术部 (联系人: 李总监)</div>
                      <div className="text-sm text-gray-700">• 产品部 (联系人: 王经理)</div>
                      <div className="text-sm text-gray-700">• 运营部 (联系人: 张主管)</div>
                    </div>
                  </div>
                  <div className="border-l-4 border-orange-500 pl-4 ml-4">
                    <div className="font-medium text-gray-800">天猫网络科技有限公司</div>
                    <div className="text-sm text-gray-600">子公司 · 上海</div>
                    <div className="mt-1 space-y-1 ml-4">
                      <div className="text-sm text-gray-700">• 研发中心 (联系人: 赵总监)</div>
                      <div className="text-sm text-gray-700">• 商务部 (联系人: 陈经理)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 行业与规模分析 */}
      <Card title="行业与规模分析">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">行业分布</h4>
            <div className="space-y-2">
              {[
                { industry: '互联网', count: 12, color: 'blue' },
                { industry: '金融', count: 8, color: 'green' },
                { industry: '制造业', count: 6, color: 'purple' },
                { industry: '教育', count: 4, color: 'orange' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${item.color}-500 rounded-full`}></span>
                    <span className="text-sm text-gray-700">{item.industry}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">规模分布</h4>
            <div className="space-y-2">
              {[
                { scale: '10000+人', count: 5, color: 'red' },
                { scale: '1000-9999人', count: 8, color: 'orange' },
                { scale: '100-999人', count: 12, color: 'yellow' },
                { scale: '100人以下', count: 5, color: 'green' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${item.color}-500 rounded-full`}></span>
                    <span className="text-sm text-gray-700">{item.scale}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">地区分布</h4>
            <div className="space-y-2">
              {[
                { region: '北京', count: 8, color: 'blue' },
                { region: '上海', count: 7, color: 'green' },
                { region: '深圳', count: 6, color: 'purple' },
                { region: '杭州', count: 4, color: 'orange' },
                { region: '其他', count: 5, color: 'gray' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${item.color}-500 rounded-full`}></span>
                    <span className="text-sm text-gray-700">{item.region}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">合作状态</h4>
            <div className="space-y-2">
              {[
                { status: '长期合作', count: 8, color: 'green' },
                { status: '活跃合作', count: 12, color: 'blue' },
                { status: '新客户', count: 6, color: 'yellow' },
                { status: '潜在客户', count: 4, color: 'gray' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${item.color}-500 rounded-full`}></span>
                    <span className="text-sm text-gray-700">{item.status}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderCooperationContract = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">合作与合同管理</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="费率与结算">
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-money-dollar-circle-line text-green-600"></i>
                <span className="font-medium text-green-800">费率管理</span>
              </div>
              <div className="text-sm text-green-700">
                管理 <span className="font-bold">{clients.length}</span> 家客户的费率和结算信息
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                { client: '阿里巴巴', rate: '20%', settlement: '月结30天', amount: '¥2,450,000' },
                { client: '腾讯', rate: '18%', settlement: '月结45天', amount: '¥1,890,000' },
                { client: '字节跳动', rate: '22%', settlement: '季结', amount: '¥3,200,000' },
                { client: '美团', rate: '19%', settlement: '月结30天', amount: '¥1,650,000' },
              ].map((item, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-gray-900">{item.client}</span>
                    <span className="text-sm font-medium text-green-600">{item.rate}</span>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                    <div>结算周期: {item.settlement}</div>
                    <div>累计金额: {item.amount}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="合同与附件管理">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-file-text-line text-blue-600"></i>
                <span className="font-medium text-blue-800">合同档案</span>
              </div>
              <div className="text-sm text-blue-700">
                已归档 <span className="font-bold">45</span> 份合同及相关附件
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                { 
                  contract: '阿里巴巴-招聘服务协议', 
                  type: '框架协议', 
                  status: '执行中', 
                  startDate: '2024-01-01',
                  endDate: '2024-12-31',
                  attachments: 3
                },
                { 
                  contract: '腾讯-项目合作协议', 
                  type: '项目协议', 
                  status: '执行中', 
                  startDate: '2024-02-15',
                  endDate: '2024-08-15',
                  attachments: 5
                },
                { 
                  contract: '字节跳动-年度服务协议', 
                  type: '年度协议', 
                  status: '待签署', 
                  startDate: '2024-03-01',
                  endDate: '2025-02-28',
                  attachments: 2
                }
              ].map((item, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-3">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-gray-900">{item.contract}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      item.status === '执行中' ? 'bg-green-100 text-green-800' :
                      item.status === '待签署' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {item.status}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-sm text-gray-600 mb-2">
                    <div>类型: {item.type}</div>
                    <div>附件: {item.attachments}个</div>
                    <div>开始: {item.startDate}</div>
                    <div>结束: {item.endDate}</div>
                  </div>
                  <div className="flex justify-end space-x-2">
                    <Button size="sm" variant="outline">查看</Button>
                    <Button size="sm" variant="outline">下载</Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>

      {/* 回款与开票信息 */}
      <Card title="回款与开票管理">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">回款统计</h4>
            <div className="space-y-3">
              <div className="bg-green-50 p-3 rounded-lg">
                <div className="text-lg font-bold text-green-600">¥8,450,000</div>
                <div className="text-sm text-green-700">本年度回款</div>
              </div>
              <div className="bg-blue-50 p-3 rounded-lg">
                <div className="text-lg font-bold text-blue-600">¥2,150,000</div>
                <div className="text-sm text-blue-700">待回款金额</div>
              </div>
              <div className="bg-orange-50 p-3 rounded-lg">
                <div className="text-lg font-bold text-orange-600">¥350,000</div>
                <div className="text-sm text-orange-700">逾期回款</div>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">开票信息</h4>
            <div className="space-y-2">
              {[
                { client: '阿里巴巴', amount: '¥450,000', status: '已开票', date: '2024-01-15' },
                { client: '腾讯', amount: '¥320,000', status: '待开票', date: '2024-01-20' },
                { client: '字节跳动', amount: '¥280,000', status: '已开票', date: '2024-01-10' },
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div>
                    <div className="text-sm font-medium text-gray-900">{item.client}</div>
                    <div className="text-xs text-gray-500">{item.amount} · {item.date}</div>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    item.status === '已开票' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {item.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">快速操作</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-file-add-line mr-2"></i>
                新建合同
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-money-dollar-circle-line mr-2"></i>
                费率调整
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-file-list-line mr-2"></i>
                开票申请
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-download-line mr-2"></i>
                导出报表
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderInteractionRecords = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">互动记录 - AI情绪与风险分析</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="会议纪要管理">
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-calendar-event-line text-purple-600"></i>
                <span className="font-medium text-purple-800">会议记录</span>
              </div>
              <div className="text-sm text-purple-700">
                本月已记录 <span className="font-bold">28</span> 场客户会议
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                {
                  title: '阿里巴巴-Q1招聘计划讨论',
                  date: '2024-01-15 14:00',
                  participants: '张总监、李HR、王经理',
                  duration: '90分钟',
                  summary: 'AI摘要：确定Q1招聘100人，重点岗位为前端、后端、产品经理',
                  sentiment: 'positive',
                  keyPoints: ['预算充足', '时间紧迫', '质量要求高']
                },
                {
                  title: '腾讯-项目合作评估',
                  date: '2024-01-12 10:30',
                  participants: '李经理、赵HR',
                  duration: '60分钟',
                  summary: 'AI摘要：对上季度合作满意，希望扩大合作范围',
                  sentiment: 'positive',
                  keyPoints: ['合作满意', '扩大范围', '长期合作']
                },
                {
                  title: '字节跳动-费率调整商讨',
                  date: '2024-01-10 16:00',
                  participants: '王总监、陈总监',
                  duration: '45分钟',
                  summary: 'AI摘要：客户希望降低费率，需要进一步协商',
                  sentiment: 'neutral',
                  keyPoints: ['费率敏感', '需要协商', '保持关系']
                }
              ].map((meeting, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-medium text-gray-900">{meeting.title}</h4>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      meeting.sentiment === 'positive' ? 'bg-green-100 text-green-800' :
                      meeting.sentiment === 'neutral' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {meeting.sentiment === 'positive' ? '积极' : 
                       meeting.sentiment === 'neutral' ? '中性' : '消极'}
                    </span>
                  </div>
                  <div className="text-sm text-gray-600 mb-2">
                    {meeting.date} · {meeting.duration} · {meeting.participants}
                  </div>
                  <div className="bg-blue-50 p-3 rounded mb-3">
                    <div className="text-sm text-blue-800">{meeting.summary}</div>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {meeting.keyPoints.map((point, i) => (
                      <span key={i} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                        {point}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="AI情绪与风险识别">
          <div className="space-y-4">
            <div className="bg-red-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-emotion-line text-red-600"></i>
                <span className="font-medium text-red-800">情绪分析引擎</span>
              </div>
              <div className="text-sm text-red-700">
                AI识别出 <span className="font-bold">3</span> 个潜在风险信号
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">风险预警</h4>
              {[
                {
                  client: '字节跳动',
                  risk: '费率敏感',
                  level: 'medium',
                  description: '近期多次提及费率问题，可能影响续约',
                  suggestion: '建议主动沟通，提供增值服务方案',
                  confidence: 78
                },
                {
                  client: '小米科技',
                  risk: '沟通频率下降',
                  level: 'low',
                  description: '本月沟通次数较上月减少60%',
                  suggestion: '主动联系，了解项目进展情况',
                  confidence: 65
                },
                {
                  client: '滴滴出行',
                  risk: '满意度下降',
                  level: 'high',
                  description: '最近反馈中出现不满情绪词汇',
                  suggestion: '紧急安排客户拜访，了解具体问题',
                  confidence: 85
                }
              ].map((risk, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-2">
                      <span className="font-medium text-gray-900">{risk.client}</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        risk.level === 'high' ? 'bg-red-100 text-red-800' :
                        risk.level === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-blue-100 text-blue-800'
                      }`}>
                        {risk.level === 'high' ? '高风险' : 
                         risk.level === 'medium' ? '中风险' : '低风险'}
                      </span>
                    </div>
                    <span className="text-sm text-gray-500">{risk.confidence}%置信度</span>
                  </div>
                  <div className="text-sm text-gray-700 mb-2">
                    <strong>风险类型:</strong> {risk.risk}
                  </div>
                  <div className="text-sm text-gray-600 mb-2">{risk.description}</div>
                  <div className="bg-blue-50 p-2 rounded text-sm text-blue-800">
                    <strong>建议:</strong> {risk.suggestion}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>

      {/* 沟通渠道统计 */}
      <Card title="沟通渠道与频次分析">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">沟通渠道分布</h4>
            <div className="space-y-2">
              {[
                { channel: '电话沟通', count: 156, percentage: 45, color: 'blue' },
                { channel: '邮件往来', count: 89, percentage: 26, color: 'green' },
                { channel: '微信聊天', count: 67, percentage: 19, color: 'purple' },
                { channel: '现场会议', count: 34, percentage: 10, color: 'orange' },
              ].map((item, index) => (
                <div key={index} className="p-2 bg-gray-50 rounded">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm text-gray-700">{item.channel}</span>
                    <span className="text-sm font-medium text-gray-900">{item.count}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1">
                    <div className={`bg-${item.color}-500 h-1 rounded-full`} style={{width: `${item.percentage}%`}}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">沟通频次</h4>
            <div className="space-y-2">
              {[
                { period: '本周', count: 45, trend: 'up' },
                { period: '本月', count: 178, trend: 'up' },
                { period: '本季度', count: 523, trend: 'stable' },
                { period: '本年度', count: 1456, trend: 'up' },
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-700">{item.period}</span>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-900">{item.count}</span>
                    <i className={`ri-arrow-${item.trend === 'up' ? 'up' : item.trend === 'down' ? 'down' : 'right'}-line text-${
                      item.trend === 'up' ? 'green' : item.trend === 'down' ? 'red' : 'gray'
                    }-600 text-sm`}></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">响应时效</h4>
            <div className="space-y-2">
              {[
                { type: '电话回拨', time: '15分钟', status: 'excellent' },
                { type: '邮件回复', time: '2小时', status: 'good' },
                { type: '微信回复', time: '30分钟', status: 'excellent' },
                { type: '会议安排', time: '1天', status: 'good' },
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-700">{item.type}</span>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-900">{item.time}</span>
                    <span className={`w-2 h-2 rounded-full ${
                      item.status === 'excellent' ? 'bg-green-500' : 
                      item.status === 'good' ? 'bg-blue-500' : 'bg-yellow-500'
                    }`}></span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">客户满意度</h4>
            <div className="space-y-2">
              <div className="bg-green-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-green-600">4.6</div>
                <div className="text-sm text-green-700">平均满意度</div>
              </div>
              <div className="space-y-1">
                {[5, 4, 3, 2, 1].map((star, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600">{star}星</span>
                    <div className="flex-1 bg-gray-200 rounded-full h-1">
                      <div className="bg-yellow-500 h-1 rounded-full" style={{
                        width: `${star === 5 ? 60 : star === 4 ? 25 : star === 3 ? 10 : star === 2 ? 3 : 2}%`
                      }}></div>
                    </div>
                    <span className="text-xs text-gray-500">
                      {star === 5 ? '60%' : star === 4 ? '25%' : star === 3 ? '10%' : star === 2 ? '3%' : '2%'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderDemandProfile = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">需求与职位画像</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="JD要点沉淀">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-file-list-line text-blue-600"></i>
                <span className="font-medium text-blue-800">JD智能分析</span>
              </div>
              <div className="text-sm text-blue-700">
                已分析 <span className="font-bold">156</span> 个JD，提取关键要点
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                {
                  client: '阿里巴巴',
                  position: '高级前端工程师',
                  keyRequirements: ['React/Vue 3年+', '大厂背景优先', '本科以上', '抗压能力强'],
                  preferredBackground: ['互联网公司', 'B端产品经验', '团队协作'],
                  salaryRange: '25K-40K',
                  urgency: 'high'
                },
                {
                  client: '腾讯',
                  position: 'Java后端工程师',
                  keyRequirements: ['Spring Boot', '微服务架构', '5年+经验', '985/211优先'],
                  preferredBackground: ['金融/支付', '高并发经验', '技术深度'],
                  salaryRange: '30K-50K',
                  urgency: 'medium'
                }
              ].map((jd, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h4 className="font-medium text-gray-900">{jd.position}</h4>
                      <p className="text-sm text-gray-600">{jd.client} · {jd.salaryRange}</p>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      jd.urgency === 'high' ? 'bg-red-100 text-red-800' :
                      jd.urgency === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-green-100 text-green-800'
                    }`}>
                      {jd.urgency === 'high' ? '紧急' : jd.urgency === 'medium' ? '一般' : '不急'}
                    </span>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <span className="text-sm font-medium text-gray-700">核心要求:</span>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {jd.keyRequirements.map((req, i) => (
                          <span key={i} className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs">
                            {req}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-700">偏好背景:</span>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {jd.preferredBackground.map((bg, i) => (
                          <span key={i} className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs">
                            {bg}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="偏好规则库">
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-settings-3-line text-purple-600"></i>
                <span className="font-medium text-purple-800">智能规则引擎</span>
              </div>
              <div className="text-sm text-purple-700">
                基于历史数据建立 <span className="font-bold">23</span> 条偏好规则
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">客户偏好规则</h4>
              {[
                {
                  client: '阿里巴巴',
                  rules: [
                    { type: '学历偏好', rule: '985/211院校优先，本科以上', weight: 85 },
                    { type: '行业偏好', rule: '互联网/电商背景优先', weight: 90 },
                    { type: '公司偏好', rule: '大厂背景(BAT/TMD)优先', weight: 80 },
                    { type: '技能偏好', rule: 'React/Vue框架必须精通', weight: 95 }
                  ]
                },
                {
                  client: '腾讯',
                  rules: [
                    { type: '学历偏好', rule: '硕士学历加分，本科底线', weight: 75 },
                    { type: '行业偏好', rule: '金融/游戏/社交产品经验', weight: 85 },
                    { type: '技能偏好', rule: '微服务架构实战经验', weight: 90 },
                    { type: '软技能', rule: '沟通能力强，团队协作', weight: 70 }
                  ]
                }
              ].map((clientRule, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <h5 className="font-medium text-gray-900 mb-3">{clientRule.client}</h5>
                  <div className="space-y-2">
                    {clientRule.rules.map((rule, i) => (
                      <div key={i} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                        <div>
                          <div className="text-sm font-medium text-gray-800">{rule.type}</div>
                          <div className="text-xs text-gray-600">{rule.rule}</div>
                        </div>
                        <div className="text-right">
                          <div className="text-sm font-medium text-purple-600">{rule.weight}%</div>
                          <div className="w-12 bg-gray-200 rounded-full h-1">
                            <div className="bg-purple-500 h-1 rounded-full" style={{width: `${rule.weight}%`}}></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>

      {/* 职位画像分析 */}
      <Card title="职位画像与匹配分析">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">热门技能需求</h4>
            <div className="space-y-2">
              {[
                { skill: 'React', demand: 45, growth: 'up' },
                { skill: 'Java', demand: 38, growth: 'stable' },
                { skill: 'Python', demand: 32, growth: 'up' },
                { skill: 'Vue', demand: 28, growth: 'up' },
                { skill: 'Go', demand: 25, growth: 'up' },
                { skill: 'Node.js', demand: 22, growth: 'stable' },
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-900">{item.skill}</span>
                    <i className={`ri-arrow-${item.growth === 'up' ? 'up' : item.growth === 'down' ? 'down' : 'right'}-line text-${
                      item.growth === 'up' ? 'green' : item.growth === 'down' ? 'red' : 'gray'
                    }-600 text-sm`}></i>
                  </div>
                  <span className="text-sm text-blue-600 font-medium">{item.demand}个职位</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">薪资分布</h4>
            <div className="space-y-2">
              {[
                { range: '50K+', count: 12, percentage: 15 },
                { range: '30K-50K', count: 28, percentage: 35 },
                { range: '20K-30K', count: 32, percentage: 40 },
                { range: '15K-20K', count: 8, percentage: 10 },
              ].map((item, index) => (
                <div key={index} className="p-2 bg-gray-50 rounded">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm text-gray-700">{item.range}</span>
                    <span className="text-sm font-medium text-gray-900">{item.count}个</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1">
                    <div className="bg-green-500 h-1 rounded-full" style={{width: `${item.percentage}%`}}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">地域分布</h4>
            <div className="space-y-2">
              {[
                { city: '北京', count: 35, percentage: 44 },
                { city: '上海', count: 22, percentage: 28 },
                { city: '深圳', count: 15, percentage: 19 },
                { city: '杭州', count: 7, percentage: 9 },
              ].map((item, index) => (
                <div key={index} className="p-2 bg-gray-50 rounded">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm text-gray-700">{item.city}</span>
                    <span className="text-sm font-medium text-gray-900">{item.count}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1">
                    <div className="bg-blue-500 h-1 rounded-full" style={{width: `${item.percentage}%`}}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderClientDevelopment = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">客户发展 - 商机与竞品分析</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="商机阶段管理">
          <div className="space-y-4">
            <div className="bg-orange-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-rocket-line text-orange-600"></i>
                <span className="font-medium text-orange-800">商机漏斗</span>
              </div>
              <div className="text-sm text-orange-700">
                当前跟进 <span className="font-bold">23</span> 个商机项目
              </div>
            </div>
            
            <div className="space-y-3">
              {[
                { stage: '初步接触', count: 8, conversion: 100, color: 'blue' },
                { stage: '需求确认', count: 6, conversion: 75, color: 'purple' },
                { stage: '方案提交', count: 4, conversion: 50, color: 'orange' },
                { stage: '商务谈判', count: 3, conversion: 38, color: 'yellow' },
                { stage: '合同签署', count: 2, conversion: 25, color: 'green' },
              ].map((stage, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-2">
                      <span className={`w-3 h-3 bg-${stage.color}-500 rounded-full`}></span>
                      <span className="font-medium text-gray-900">{stage.stage}</span>
                    </div>
                    <div className="text-right">
                      <span className="text-sm font-medium text-gray-900">{stage.count}个</span>
                      <div className="text-xs text-gray-500">{stage.conversion}%转化</div>
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className={`bg-${stage.color}-500 h-2 rounded-full`} style={{width: `${stage.conversion}%`}}></div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg">
              <h5 className="font-medium text-green-800 mb-2">重点商机</h5>
              <div className="space-y-2">
                {[
                  { company: '小米科技', stage: '商务谈判', value: '¥500,000', probability: 80 },
                  { company: '滴滴出行', stage: '方案提交', value: '¥300,000', probability: 60 },
                  { company: '美团', stage: '需求确认', value: '¥400,000', probability: 45 },
                ].map((opportunity, index) => (
                  <div key={index} className="flex items-center justify-between p-2 bg-white rounded">
                    <div>
                      <div className="text-sm font-medium text-gray-900">{opportunity.company}</div>
                      <div className="text-xs text-gray-600">{opportunity.stage} · {opportunity.value}</div>
                    </div>
                    <span className="text-sm font-medium text-green-600">{opportunity.probability}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>

        <Card title="竞品客户洞察">
          <div className="space-y-4">
            <div className="bg-red-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-spy-line text-red-600"></i>
                <span className="font-medium text-red-800">竞品分析</span>
              </div>
              <div className="text-sm text-red-700">
                监控 <span className="font-bold">15</span> 家竞争对手的客户动态
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">竞争对手分析</h4>
              {[
                {
                  competitor: '智联招聘',
                  sharedClients: 8,
                  advantages: ['品牌知名度', '平台流量大'],
                  weaknesses: ['服务个性化不足', '响应速度慢'],
                  threat: 'medium'
                },
                {
                  competitor: '猎聘网',
                  sharedClients: 5,
                  advantages: ['中高端定位', '猎头服务专业'],
                  weaknesses: ['价格偏高', '覆盖面有限'],
                  threat: 'high'
                },
                {
                  competitor: '前程无忧',
                  sharedClients: 12,
                  advantages: ['历史悠久', '客户基础大'],
                  weaknesses: ['技术创新不足', '用户体验一般'],
                  threat: 'low'
                }
              ].map((comp, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-2">
                    <h5 className="font-medium text-gray-900">{comp.competitor}</h5>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-gray-600">{comp.sharedClients}个共同客户</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        comp.threat === 'high' ? 'bg-red-100 text-red-800' :
                        comp.threat === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-green-100 text-green-800'
                      }`}>
                        {comp.threat === 'high' ? '高威胁' : comp.threat === 'medium' ? '中威胁' : '低威胁'}
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="font-medium text-green-700">优势:</span>
                      <ul className="mt-1 space-y-1">
                        {comp.advantages.map((adv, i) => (
                          <li key={i} className="text-green-600">• {adv}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <span className="font-medium text-red-700">劣势:</span>
                      <ul className="mt-1 space-y-1">
                        {comp.weaknesses.map((weak, i) => (
                          <li key={i} className="text-red-600">• {weak}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>

      {/* AI新闻监测与招聘态势 */}
      <Card title="AI新闻监测与招聘态势分析">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">行业新闻监测</h4>
            <div className="space-y-3">
              {[
                {
                  company: '阿里巴巴',
                  news: '宣布新一轮组织架构调整，预计新增500个技术岗位',
                  impact: 'positive',
                  time: '2小时前',
                  source: '36氪',
                  relevance: 95
                },
                {
                  company: '腾讯',
                  news: '启动数字化转型项目，大量招聘AI工程师',
                  impact: 'positive',
                  time: '5小时前',
                  source: '钛媒体',
                  relevance: 88
                },
                {
                  company: '字节跳动',
                  news: '海外业务收缩，部分岗位可能受影响',
                  impact: 'negative',
                  time: '1天前',
                  source: '财经网',
                  relevance: 72
                },
                {
                  company: '美团',
                  news: 'Q4财报超预期，计划扩大技术团队',
                  impact: 'positive',
                  time: '2天前',
                  source: '新浪财经',
                  relevance: 85
                }
              ].map((news, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-3">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-gray-900">{news.company}</span>
                    <div className="flex items-center space-x-2">
                      <span className={`w-2 h-2 rounded-full ${
                        news.impact === 'positive' ? 'bg-green-500' : 
                        news.impact === 'negative' ? 'bg-red-500' : 'bg-yellow-500'
                      }`}></span>
                      <span className="text-xs text-gray-500">{news.relevance}%相关</span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-700 mb-2">{news.news}</p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span>{news.source}</span>
                    <span>{news.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">招聘态势分析</h4>
            <div className="space-y-3">
              <div className="bg-blue-50 p-3 rounded-lg">
                <h5 className="font-medium text-blue-800 mb-2">市场热度指数</h5>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-2xl font-bold text-blue-600">78</div>
                    <div className="text-sm text-blue-700">整体热度</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-green-600">+12%</div>
                    <div className="text-sm text-green-700">环比增长</div>
                  </div>
                </div>
              </div>
              
              <div className="space-y-2">
                <h5 className="font-medium text-gray-800">行业招聘趋势</h5>
                {[
                  { industry: '互联网', trend: 'up', change: '+15%', jobs: 1250 },
                  { industry: '金融科技', trend: 'up', change: '+8%', jobs: 680 },
                  { industry: '人工智能', trend: 'up', change: '+25%', jobs: 420 },
                  { industry: '电商', trend: 'stable', change: '+2%', jobs: 890 },
                  { industry: '游戏', trend: 'down', change: '-5%', jobs: 320 },
                ].map((trend, index) => (
                  <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-gray-700">{trend.industry}</span>
                      <i className={`ri-arrow-${trend.trend === 'up' ? 'up' : trend.trend === 'down' ? 'down' : 'right'}-line text-${
                        trend.trend === 'up' ? 'green' : trend.trend === 'down' ? 'red' : 'gray'
                      }-600 text-sm`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-gray-900">{trend.jobs}个职位</div>
                      <div className={`text-xs ${
                        trend.trend === 'up' ? 'text-green-600' : trend.trend === 'down' ? 'text-red-600' : 'text-gray-600'
                      }`}>
                        {trend.change}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-yellow-50 p-3 rounded-lg">
                <h5 className="font-medium text-yellow-800 mb-2">机会预警</h5>
                <div className="space-y-1 text-sm text-yellow-700">
                  <div>• 阿里巴巴架构调整，技术岗位需求激增</div>
                  <div>• 腾讯AI项目启动，相关人才稀缺</div>
                  <div>• 美团业绩良好，扩招计划确定</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* 标签页导航 */}
        <div className="mb-8">
          <nav className="flex space-x-8">
            {[
              { id: 'list', name: '客户列表', icon: 'ri-building-line' },
              { id: 'archive', name: '客户档案', icon: 'ri-folder-line' },
              { id: 'cooperation', name: '合作合同', icon: 'ri-file-text-line' },
              { id: 'interaction', name: '互动记录', icon: 'ri-chat-3-line' },
              { id: 'demand', name: '需求画像', icon: 'ri-user-search-line' },
              { id: 'development', name: '客户发展', icon: 'ri-line-chart-line' },
              { id: 'ai', name: 'AI功能', icon: 'ri-brain-line' },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* 标签页内容 */}
        {activeTab === 'list' && renderClientList()}
        {activeTab === 'archive' && renderClientArchive()}
        {activeTab === 'cooperation' && renderCooperationContract()}
        {activeTab === 'interaction' && renderInteractionRecords()}
        {activeTab === 'demand' && renderDemandProfile()}
        {activeTab === 'development' && renderClientDevelopment()}
        {activeTab === 'ai' && renderAIFeatures()}
      </div>

      {renderClientDetail()}
    </div>
  );
}
